/**
 * Created by karora on 11/03/17.
 */
import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  selector: 'hub-dashboard',
  template: `<div class="blocks">
  <dash-versions></dash-versions>
  <dash-issues></dash-issues>
  <dash-health-counts></dash-health-counts>
</div>
<div class="active-issues">
  <hub-issues></hub-issues>
</div>
`,
  styles: [
    `.blocks { display: block; width: 100%; min-height: 3em; height: auto}`
  ],
})

export class DashboardComponent implements OnInit {
  errorMessage: string;

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('Dashboard');
  }

}
